import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import $api from './axios';

const request = async function R<T>(options: AxiosRequestConfig): Promise<T> {
  const onSuccess = function S(response: AxiosResponse) {
    const { data } = response;
    return data;
  };

  const onError = async (error: AxiosError) => {
    return Promise.reject(error);
  };

  return $api(options).then(onSuccess).catch(onError);
};

export default request;
